

const { ccclass, property } = cc._decorator;


export class BiPaiGoldGameResultData{
    showShareTips?: boolean
    shareTips?: string
    backBtnCallback: Function
    continueBtnCallback: Function
    isWin: boolean
    score: number

    openingMultiple?: number
    followScore?: number
    firstOpenMultiple?: number
    followMultiple?: number
    normalOpenMultiple?: number
    specailOpenMultiple?: number
    ziMoMultiple?: number
    fangPaoMultiple?: number
    roundScore?: number
}
